export const pageNumberValue = 1;
export const pageSizeValue = 20;

export const employmentTypeId = [
	{ id: 1, type: "Full-time" },
	{ id: 2, type: "Part-Time" },
	{ id: 3, type: "Contractor" },
];
export const identificationTypeId = [
	{ id: 1, type: "National Id" },
	{ id: 2, type: "Iqama Id" },
	{
		id: 3,
		type: "Passport Number",
	},
];
export const nationalityId = [
	{ id: 1, type: "Saudi" },
	{ id: 2, type: "Non-Saudi" },
];

export const genderId = [
	{ id: 1, type: "Male" },
	{ id: 2, type: "Female" },
];

export const onOffMode = [
	{ id: 0, type: "Off" },
	{ id: 1, type: "On" },
]

export const accessType = [
	{ id: 0, type: "Pin" },
	{ id: 1, type: "Card" },
]
export const _4gSwitch = [
	{ id: 0, type: "Off" },
	{ id: 1, type: "On" },
]
export const toggleState = [
	{ id: 0, type: "Off" },
	{ id: 1, type: "On" },
]
export const displayTimeMode= [
	{ id: 12, type: "Display_12" },
	{ id: 24, type: "Display_24" },
]
export const validCardTone = [
	{ id: 0, type: "On" },
	{ id: 1, type: "Off" },
	{ id: 2, type: "Tone_1" },
	{ id: 3, type: "Tone_2" },
	{ id: 4, type: "OfTone_3" },
]

export const heaterSWMode = [
	{ id: 0, type: "Auto" },
	{ id: 1, type: "Off" },
	{ id: 2, type: "On" },

]

export const cryptoMethod = [
	{ id: 0, type: "DES" },
	{ id: 1, type: "Key3DES" },
	{ id: 2, type: "AES" },

]
export const slaveReaderSwitch = [
	{ id: 0, type: "Off" },
	{ id: 1, type: "On" },
]
export const onlineAPB = [
	{ id: 0, type: "Off" },
	{ id: 1, type: "On" },
]
export const authMode = [
	{ id: 0, type: "Card Only" },
	{ id: 1, type: "Card And Pin" },
	{ id: 2, type: "Card Or Pin" },
]

export const doorState = [
	{ id: 0, type: "Close" },
	{ id: 1, type: "Open" },
]
export const doorControl = [
	{ id: 0, type: "Off" },
	{ id: 1, type: "On" },
]
export const alarmMode = [
	{ id: 0, type: "Off" },
	{ id: 1, type: "On" },
]
export const speakerVolume = [
	{ id: 0, type: "_0" },
	{ id: 1, type: "_30" },
	{ id: 2, type: "_70" },
]
export const screenBrightness = [
	{ id: 0, type: "_100" },
	{ id: 1, type: "_20" },
	{ id: 2, type: "_40" },
]
export const fontType = [
	{ id: 0, type: "Senserif" },
	{ id: 1, type: "Arial" },
	{ id: 2, type: "Fmhei" },
	{ id: 3, type: "Courier" },
	{ id: 4, type: "Helvetica" },
]

export const qRCodeEnableState = [
	{ id: 0, type: "Off" },
	{ id: 1, type: "On" }
]
export const taskType = [
	{ id: 1, type: "IncidentControl" },
	{ id: 2, type: "Maintenance" },
];

export const servierity = [
	{ id: 1, value: 1, type: "Minor" },
	{ id: 2, value: 2, type: "Medium" },
	{ id: 3, value: 3, type: "Major" },
];

export const status = [
	{ id: 1, value: 1, type: "Pending" },
	{ id: 2, value: 2, type: "InProgress" },
	{ id: 3, value: 3, type: "Complete" },
];

export const operatorRoleType = [
	{ id: 1, value: 1, type: "Mobile" },
	{ id: 2, value: 2, type: "Web" },
];

export const frequency = [
	{ id: 1,  type: "Daily" },
	{ id: 2,  type: "Weekly" },
	{ id: 3,  type: "Monthly" },
];

export const eventType = [
	{ id: 1, type: "Access Control Event" },
	{ id: 2,  type: "Visitor Control Event" },
//	{ id: 3,  type: "Booking Control Event" },
//	{ id: 4,  type: "Time Attendance Event" },
	{ id: 5,  type: "Canteen Control Event" },
];

export const relayMode = [
	{ id: 0, type: "Normal operation" },
	{ id: 1,  type: "Relay open" },
	{ id: 2,  type: "Relay closed" },
];
